import AppState from '@state';

const useToastAlertError = (message) => {
  AppState.messages.toastMessage.value = { text: message, variant: 'error' };
};

export default useToastAlertError;
